export const iconFontAwesomeAlphabetI = (
	<i className="fa-solid fa-i"></i>
);
